import { defineStore } from 'pinia';

export interface IToast {
  title: string;
  message: string;
  type: string;
  duration: number;
}

export interface IInternalToast extends IToast {
  id: string;
}

export interface IToastState {
  toasts: Array<IInternalToast>;
}

export const useToastStore = defineStore('toast', {
  state: (): IToastState => {
    return {
      toasts: [],
    };
  },
  actions: {
    addToast(toast: IToast): void {
      this.toasts.push({
        ...toast,
        id: Math.random().toString(36).substring(7),
      });
    },
  },
});
